const MAANDEN_VOL = [
    "januari", "februari", "maart", "april", "mei", "juni",
    "juli", "augustus", "september", "oktober", "november", "december",
];

/** ISO-datum naar Nederlands formaat, bijv. "6 oktober 2026". */
export function formatDatumNL(iso) {
    if (!iso) return "";
    const d = new Date(iso);
    return `${d.getDate()} ${MAANDEN_VOL[d.getMonth()]} ${d.getFullYear()}`;
}
